/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AccountsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type UsageType =
  | 'CONTACT_SCORING_RULESET'
  | 'CRM_VIEW'
  | 'FORM'
  | 'WORKFLOW'
  | 'PROPERTY'
  | 'CALCULATED_PROPERTY'
  | 'ROLLUP_PROPERTY'
  | 'INBOUNDDB_LISTS'
  | 'INBOUNDDB_FILTER'
  | 'BOT'
  | 'PIPELINE_STAGE'
  | 'CONVERSATIONS_CONNECTED_ACCOUNT'
  | 'FEEDBACK_SURVEY'
  | 'AUTOMATION_PLATFORM_FLOW'
  | 'OBJECT_REQUIREMENT'
  | 'UNIFIED_EVENTS_PUBSUB_FILTER'
  | 'ADS_AUDIENCE'
  | 'OBJECT_SCORE_PROPERTY'
  | 'FLOW_ACTION'
  | 'EMAIL'
  | 'UNIFIED_EVENT_PROPERTY'
  | 'REPORT'
  | 'USER'
  | 'TEAM'
  | 'INTEGRATION'
  | 'PORTAL_SPECIFIC_OBJECT'
  | 'CONTENT'
  | 'LANDING_PAGE'
  | 'SITE_PAGE'
  | 'BLOG_POST'
  | 'KNOWLEDGE_ARTICLE'
  | 'LEGACY_PAGE'
  | 'CONTENT_GROUP'
  | 'BLOG'
  | 'KNOWLEDGE_BASE'
  | 'PIPELINE'
  | 'LAYOUT'
  | 'ASSOCIATION_CARD'
  | 'PIPELINE_BOARD_VIEW'
  | 'PORTAL_SPECIFIC_EVENT'
  | 'DATA_SYNC_MAPPING'
  | 'DATASET'
  | 'ASSOCIATION_DEFINITION'
  | 'CUSTOM_VIEW'
  | 'DATA_SYNC_LIFECYCLE_RULE'
  | 'SEQUENCE'
  | 'TICKET_RULE'
  | 'PIPELINE_STAGE_NOTIFICATION_ONLY'
  | 'DATA_SYNC_DEAL_STAGE_RULE'
  | 'SMART_CONTENT'
  | 'SALES_VIEW'
  | 'PAYMENT_LINK'
  | 'MEETING'
  | 'DATA_SYNC_LIST'
  | 'DEPENDENT_CONDITIONAL_PROPERTY'
  | 'CONTROLLING_CONDITIONAL_PROPERTY'
  | 'DATA_SYNC_ORDER_STAGE_RULE'
  | 'DEPENDENT_CONDITIONAL_FIELD'
  | 'CONTROLLING_CONDITIONAL_FIELD'
  | 'GOAL_TARGET'
  | 'PIPELINE_OBJECT_TAG'
  | 'CONTROLLING_CONDITIONAL_OPTIONS_FIELD'
  | 'DATA_SYNC_STAGE_RULE'
  | 'MARKETING_SMS'
  | 'ROOT_MIC'
  | 'DATA_HIGHLIGHTS_CARD'
  | 'ASSOCIATION_TABLE_CARD'
  | 'DATA_SYNC_FILTER_PROPERTY'
  | 'PROPERTIES_LIST_CARD'
  | 'ASSOCIATION_LABEL_LIST_CARD'
  | 'LEGACY_CTA'
  | 'DASHBOARD'
  | 'PROPERTIES_V3_CARD'
  | 'SKILL'
  | 'ASSOCIATION_V3_CARD'
  | 'CONTROLLING_PIPELINE_STAGE_FIELD'
  | 'DATA_SYNC_PORTAL_SPECIFIC_OBJECT'
  | 'AUDIENCE'
  | 'CALL_TO_ACTION'
  | 'SCORE_CONFIGURATION'
  | 'AUTOMATION_JOURNEY'
  | 'AUTOMATION_JOURNEY_STAGE'
  | 'AUTOMATION_JOURNEY_STAGE_ACTION'
  | 'GLOBAL_DATASET'
  | 'STATISTICS_CARD'
  | 'SVH_SCORE_CONFIGURATION'
  | 'MH_SCORE_CONFIGURATION'
  | 'ACCEPTANCE_TEST'
  | 'ROSTER'
  | 'QUICK_ACTIONS_CARD'
  | 'STANDARD_CRM_CARDS'
  | 'CUSTOMER_SUCCESS_WORKSPACE_SETTINGS'
  | 'LEGACY_EVENT'
  | 'DATA_INTEGRATION_ACCOUNT'
  | 'APP_DATA_SOURCE'
  | 'CHATFLOW'
  | 'APP_DATA_SOURCE_FIELD'
  | 'DATASET_TO_CRM'
  | 'UNIFIED_EVENT'
  | 'DATASET_SUBVIEW'
  | 'SALES_WORKSPACE_TARGET_ACCOUNTS_SETTINGS'
  | 'INTEGRATOR_EVENT'
  | 'APP_OBJECT'
  | 'DATASET_EXPORT_FIELD'
  | 'CRM_CONTAINER_VIEW'
  | 'AUTOMATION_ACTION_DEFINITION'
  | 'AI_AGENT_TEMPLATE'
  | 'AI_AGENT_INSTANCE'
  | 'SLA_RULE_CONFIG'
  | 'DATASET_TO_SHEETS'
  | 'MARKETING_EVENT'
  | 'SEGMENT'
  | 'CUSTOMER_AGENT'
  | 'PERSONALIZATION'
  | 'UNIFIED_EVENT_ENRICHED_PROPERTY'
  | 'PERSONALIZATION_STRATEGY'
  | 'WRITE_TO_CRM'
  | 'ENRICHMENT_PROPERTY_MAPPING'
  | 'CAMPAIGN'
  | 'MACRO'
  | 'CUSTOMER_AGENT_CRM_TOOL_PROPERTY'
  | 'CUSTOMER_AGENT_ACTION'
  | 'CUSTOMER_AGENT_PROCESS'
  | 'SMART_DATA_CAPTURE'
  | 'ENGAGEMENT_PROPERTY_CONFIG'
  | 'QUOTE_RULE'
  | 'CUSTOM_METRIC'
  | 'LOOKUP_PROPERTY'
  | 'CUSTOMER_AGENT_SEGMENT'
  | 'AUTOMATION_TRIGGER_DEFINITION'
  | 'DUPLICATE_RECORD_DETECTION_RULE'
  | 'DUPLICATE_RECORD_MERGE_RULE'
  | 'CUSTOMER_SUCCESS_HEALTH_ASSESSMENT_SETTINGS'
  | unhandledEnumCase;

export type AccountStatus =
  | 'AUTHENTICATED'
  | 'DISCONNECTED'
  | 'REAUTH_REQUIRED'
  | 'UNKNOWN'
  | unhandledEnumCase;

export type AccountVerificationsGetError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type AccountVerificationsResponse = {
  accountId: number;
  status: AccountVerificationStatus;
  verifiedAt: number;
  appId: number;
  requiresReauthentication?: boolean;
};

export type AppAccountsGetError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type AppAccountsResponseAccount = {
  accountId: number;
  accountName: string;
  accountIdentifier: string;
  accountInstance?: string;
  userId: number;
};

export type AppAccountsResponseV2 = {
  appId: number;
  appName: string;
  appLevel: AppLevel;
  accounts: Default<AppAccountsResponseAccount[]>;
};

export type AppLevel = 'PORTAL' | 'USER' | unhandledEnumCase;

export type GetAccountVerificationsRequest = { accountIds: Default<number[]> };

export type GetAccountVerificationsResponse = {
  verifications: Default<AccountVerificationsResponse[]>;
};

export type GetAppAccountsRequest = { filterOnAppIds: Default<number[]> };

export type GetAppAccountsResponse = {
  accounts: Default<AppAccountsResponseV2[]>;
};

export type RemoteAccount = {
  usages: Default<RemoteAccountUsage[]>;
  id: number;
  accountName: string;
  accountIdentifier: string;
  accountInstance?: string;
  connectionIds: Default<number[]>;
  deletedAt?: number;
  authToken?: string;
};

export type RemoteAccountBase = {
  id: number;
  accountName: string;
  accountIdentifier: string;
  accountInstance?: string;
  connectionIds: Default<number[]>;
  deletedAt?: number;
  authToken?: string;
};

export type RemoteAccountBasesResponse = {
  accounts: Default<RemoteAccountBase[]>;
};

export type RemoteAccountGetError = {
  reason: GetErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type RemoteAccountRequest = {
  accountId: number;
  includeDeleted: Default<boolean>;
};

export type RemoteAccountUsage = {
  label?: string;
  uri?: string;
  usageType: UsageType;
  usageName: string;
};

export type RemoteAccountsGetError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type RemoteAccountsRequest = {
  appId: number;
  includeDeleted: Default<boolean>;
};

export type RemoteAccountsResponse = { accounts: Default<RemoteAccount[]> };

export type VerifyAccountResponse = {
  accountId: number;
  status: AccountStatus;
  error?: string;
  errorMessage?: string;
};

export type VerifyAccountsError = {
  notFoundAccountIds: Default<number[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type VerifyAccountsRequest = { accountIds: Default<number[]> };

export type VerifyAccountsResponse = {
  accounts: Default<VerifyAccountResponse[]>;
};

export type GetErrorReason = 'NOT_FOUND' | unhandledEnumCase;

export type AccountVerificationStatus =
  | 'CONNECTED'
  | 'IN_PROGRESS'
  | 'DISCONNECTED'
  | unhandledEnumCase;

export type AvailableDatasetParameter = {
  available: boolean;
  label: string;
  name: string;
  type: DatasetType;
  value?: DatasetParameterValue;
  /** @deprecated */
  refreshOnChange: Default<boolean>;
  options: Default<DatasetParameterValue[]>;
};

export type DatasetParameter = {
  name: string;
  value: string;
  label: Default<string>;
};

export type DatasetParameterInfo = {
  label: string;
  name: string;
  type: DatasetType;
  dependsOn: Default<string[]>;
};

export type DatasetParameterRequest = {
  remoteObjectType: string;
  parameters: Default<DatasetParameter[]>;
};

export type DatasetParameterValue = { label: string; value: string };

export type DatasetParameterValueOption = {
  value: DatasetParameterValue;
  enabled: boolean;
};

export type DatasetType =
  | 'GENERAL'
  | 'SCOPE'
  | 'LAST_MODIFIED'
  | 'RECORD_ID'
  | 'DEFAULT_VALUE'
  | 'SUBSCRIPTION_SETTING'
  | unhandledEnumCase;

export type FetchDatasetParameterResponse = {
  label: string;
  name: string;
  type: DatasetType;
  options: Default<DatasetParameterValueOption[]>;
};

export type AuthenticateNewAccountError = {
  reason: Default<ComHubspotPiesyncBridgeModelsAccountAbstractAuthenticateNewAccountError.FailureReason>;
  duplicateAccountId?: string;
  accountName?: string;
  accountIdentifier?: string;
  appId?: string;
  remoteErrorReason?: string;
  remoteErrorMessage?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type AuthenticateNewAccountRequest = { appId: number; secretId: string };

export type ConnectorErrorType =
  | 'UNKNOWN'
  | 'RATE_LIMIT_REACHED'
  | 'AUTH_FAILED'
  | 'QUOTA_REACHED'
  | 'FAILED'
  | unhandledEnumCase;

export type DeleteAccountError = {
  reason?: ComHubspotPiesyncBridgeModelsAccountAbstractDeleteAccountError.FailureReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DeleteAccountRequest = { accountId: number };

export type DeleteAccountResponse = {};

export type FetchDatasetParameterValuesError = {
  connectorErrorType: Default<ConnectorErrorType>;
  connectorErrorMessage: Default<string>;
  missingParameters: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type FetchDatasetParameterValuesRequest = {
  accountId: number;
  remoteObjectType: string;
  selectedParameters: Default<DatasetParameter[]>;
  parameter: string;
};

export type GetAvailablePartitionsError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetAvailablePartitionsRequest = {
  accountId: number;
  objectTypeKeyString: string;
};

export type GetAvailablePartitionsResponse = {
  partitions: Default<AvailablePartition[]>;
};

export type ListDatasetParametersError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ListDatasetParametersRequest = {
  accountId: number;
  remoteObjectType: string;
};

export type ListDatasetParametersResponse = {
  parameters: Default<DatasetParameterInfo[]>;
};

export type ReauthenticateAccountError = {
  reason: Default<ComHubspotPiesyncBridgeModelsAccountAbstractReauthenticateAccountError.FailureReason>;
  accountId?: string;
  appId?: string;
  remoteErrorReason?: string;
  remoteErrorMessage?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ReauthenticateAccountRequest = {
  accountId: number;
  secretId: string;
};

export type RefreshVerificationsError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type RefreshVerificationsRequest = { accountIds: Default<number[]> };

export type RefreshVerificationsResponse = {};

export namespace ComHubspotPiesyncBridgeModelsAccountAbstractAuthenticateNewAccountError {
  export type FailureReason =
    | 'SYNC_ALREADY_INSTALLED'
    | 'USER_LEVEL_APP_INSTALL_FORBIDDEN'
    | 'APP_NOT_FOUND'
    | 'REMOTE_ACCOUNT_ERROR'
    | unhandledEnumCase;
}

export namespace ComHubspotPiesyncBridgeModelsAccountAbstractDeleteAccountError {
  export type FailureReason = 'ACCOUNT_NOT_FOUND' | unhandledEnumCase;
}

export namespace ComHubspotPiesyncBridgeModelsAccountAbstractReauthenticateAccountError {
  export type FailureReason =
    | 'ACCOUNT_NOT_FOUND'
    | 'REAUTHENTICATION_ACCOUNT_MISMATCH'
    | 'REMOTE_ACCOUNT_ERROR'
    | unhandledEnumCase;
}

export type GetDatasetParametersError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetDatasetParametersRequest = {
  accountId: number;
  datasetParameterRequest: DatasetParameterRequest;
};

export type GetDatasetParametersResponse = {
  parameters: Default<AvailableDatasetParameter[]>;
};

export type AvailablePartition = {
  connectionId?: number;
  id: string;
  label: string;
};

export type VerifyAccountsRequestType = Requestify<VerifyAccountsRequest>;
export type VerifyAccountsResponseType = VerifyAccountsResponse;
export type VerifyAccountsErrorType = VerifyAccountsError & HubspotMetadata;
export const verifyAccountsRpc: ChirpAvroRpcDetails<
  VerifyAccountsRequestType,
  VerifyAccountsResponseType,
  VerifyAccountsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'verifyAccounts',
  auth: 'app',
  fingerprint: '-ORqsy_IY_lxRdEOGzF9bd_U_jl4AGso',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetRemoteAccountRequestType = Requestify<RemoteAccountRequest>;
export type GetRemoteAccountResponseType = RemoteAccount;
export type GetRemoteAccountErrorType = RemoteAccountGetError & HubspotMetadata;
export const getRemoteAccountRpc: ChirpAvroRpcDetails<
  GetRemoteAccountRequestType,
  GetRemoteAccountResponseType,
  GetRemoteAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccount',
  auth: 'app',
  fingerprint: 'l_9qiaJjpjRCLz0wYnVwJK9dLsYDa9F6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetRemoteAccountsRequestType = Requestify<RemoteAccountsRequest>;
export type GetRemoteAccountsResponseType = RemoteAccountsResponse;
export type GetRemoteAccountsErrorType = RemoteAccountsGetError &
  HubspotMetadata;
export const getRemoteAccountsRpc: ChirpAvroRpcDetails<
  GetRemoteAccountsRequestType,
  GetRemoteAccountsResponseType,
  GetRemoteAccountsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccounts',
  auth: 'app',
  fingerprint: 'NnMFVxjQHq2EO3vmBB9duUKDpks6CVLS',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetRemoteAccountBaseRequestType = Requestify<RemoteAccountRequest>;
export type GetRemoteAccountBaseResponseType = RemoteAccountBase;
export type GetRemoteAccountBaseErrorType = RemoteAccountGetError &
  HubspotMetadata;
export const getRemoteAccountBaseRpc: ChirpAvroRpcDetails<
  GetRemoteAccountBaseRequestType,
  GetRemoteAccountBaseResponseType,
  GetRemoteAccountBaseErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccountBase',
  auth: 'app',
  fingerprint: 'l_9qiaJjpjQyjI5ORhah169dLsYDa9F6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetRemoteAccountBasesRequestType =
  Requestify<RemoteAccountsRequest>;
export type GetRemoteAccountBasesResponseType = RemoteAccountBasesResponse;
export type GetRemoteAccountBasesErrorType = RemoteAccountsGetError &
  HubspotMetadata;
export const getRemoteAccountBasesRpc: ChirpAvroRpcDetails<
  GetRemoteAccountBasesRequestType,
  GetRemoteAccountBasesResponseType,
  GetRemoteAccountBasesErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccountBases',
  auth: 'app',
  fingerprint: 'NnMFVxjQHq1R4kKyQsGDqEKDpks6CVLS',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteAccountRequestType = Requestify<DeleteAccountRequest>;
export type DeleteAccountResponseType = DeleteAccountResponse;
export type DeleteAccountErrorType = DeleteAccountError & HubspotMetadata;
export const deleteAccountRpc: ChirpAvroRpcDetails<
  DeleteAccountRequestType,
  DeleteAccountResponseType,
  DeleteAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'deleteAccount',
  auth: 'app',
  fingerprint: '9fOp5utrMMi00B7sPuqGXitDYthdTNCh',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RefreshVerificationsRequestType =
  Requestify<RefreshVerificationsRequest>;
export type RefreshVerificationsResponseType = RefreshVerificationsResponse;
export type RefreshVerificationsErrorType = RefreshVerificationsError &
  HubspotMetadata;
export const refreshVerificationsRpc: ChirpAvroRpcDetails<
  RefreshVerificationsRequestType,
  RefreshVerificationsResponseType,
  RefreshVerificationsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'refreshVerifications',
  auth: 'app',
  fingerprint: 'TY0NVWxKkV8NPYfeIvnyrSefKFTkASdU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppAccountsRequestType = Requestify<GetAppAccountsRequest>;
export type GetAppAccountsResponseType = GetAppAccountsResponse;
export type GetAppAccountsErrorType = AppAccountsGetError & HubspotMetadata;
export const getAppAccountsRpc: ChirpAvroRpcDetails<
  GetAppAccountsRequestType,
  GetAppAccountsResponseType,
  GetAppAccountsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getAppAccounts',
  auth: 'app',
  fingerprint: '7Xspv62sv5tyK8tRowhDAnhXjEVTLr-Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAccountVerificationsRequestType =
  Requestify<GetAccountVerificationsRequest>;
export type GetAccountVerificationsResponseType =
  GetAccountVerificationsResponse;
export type GetAccountVerificationsErrorType = AccountVerificationsGetError &
  HubspotMetadata;
export const getAccountVerificationsRpc: ChirpAvroRpcDetails<
  GetAccountVerificationsRequestType,
  GetAccountVerificationsResponseType,
  GetAccountVerificationsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getAccountVerifications',
  auth: 'app',
  fingerprint: 'ZmlVusUtSOOi3cyvbON-7u3WoH4NdXbj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListDatasetParametersRequestType =
  Requestify<ListDatasetParametersRequest>;
export type ListDatasetParametersResponseType = ListDatasetParametersResponse;
export type ListDatasetParametersErrorType = ListDatasetParametersError &
  HubspotMetadata;
export const listDatasetParametersRpc: ChirpAvroRpcDetails<
  ListDatasetParametersRequestType,
  ListDatasetParametersResponseType,
  ListDatasetParametersErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'listDatasetParameters',
  auth: 'app',
  fingerprint: 'QZUF09h2PKt8al_sO5AUuEuHZ0EBUhLr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchDatasetParameterValuesRequestType =
  Requestify<FetchDatasetParameterValuesRequest>;
export type FetchDatasetParameterValuesResponseType =
  FetchDatasetParameterResponse;
export type FetchDatasetParameterValuesErrorType =
  FetchDatasetParameterValuesError & HubspotMetadata;
export const fetchDatasetParameterValuesRpc: ChirpAvroRpcDetails<
  FetchDatasetParameterValuesRequestType,
  FetchDatasetParameterValuesResponseType,
  FetchDatasetParameterValuesErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'fetchDatasetParameterValues',
  auth: 'app',
  fingerprint: 'thIaJD9V1a2_pb7L0A5smYK9MHaL65T4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetDatasetParametersRequestType =
  Requestify<GetDatasetParametersRequest>;
export type GetDatasetParametersResponseType = GetDatasetParametersResponse;
export type GetDatasetParametersErrorType = GetDatasetParametersError &
  HubspotMetadata;
export const getDatasetParametersRpc: ChirpAvroRpcDetails<
  GetDatasetParametersRequestType,
  GetDatasetParametersResponseType,
  GetDatasetParametersErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getDatasetParameters',
  auth: 'app',
  fingerprint: 'wGZFyCwzFMo6ZRx2guwTkKDOBzmrHy5g',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAvailablePartitionsRequestType =
  Requestify<GetAvailablePartitionsRequest>;
export type GetAvailablePartitionsResponseType = GetAvailablePartitionsResponse;
export type GetAvailablePartitionsErrorType = GetAvailablePartitionsError &
  HubspotMetadata;
export const getAvailablePartitionsRpc: ChirpAvroRpcDetails<
  GetAvailablePartitionsRequestType,
  GetAvailablePartitionsResponseType,
  GetAvailablePartitionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getAvailablePartitions',
  auth: 'app',
  fingerprint: '2aGGZ3A_772s8ifWzKE6hjU-RzScQX1T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ReauthenticateAccountRequestType =
  Requestify<ReauthenticateAccountRequest>;
export type ReauthenticateAccountResponseType = RemoteAccount;
export type ReauthenticateAccountErrorType = ReauthenticateAccountError &
  HubspotMetadata;
export const reauthenticateAccountRpc: ChirpAvroRpcDetails<
  ReauthenticateAccountRequestType,
  ReauthenticateAccountResponseType,
  ReauthenticateAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'reauthenticateAccount',
  auth: 'app',
  fingerprint: 'Lgs6wnrPk_JCLz0wYnVwJOR7eQalPYiy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type AuthenticateNewAccountRequestType =
  Requestify<AuthenticateNewAccountRequest>;
export type AuthenticateNewAccountResponseType = RemoteAccount;
export type AuthenticateNewAccountErrorType = AuthenticateNewAccountError &
  HubspotMetadata;
export const authenticateNewAccountRpc: ChirpAvroRpcDetails<
  AuthenticateNewAccountRequestType,
  AuthenticateNewAccountResponseType,
  AuthenticateNewAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'authenticateNewAccount',
  auth: 'app',
  fingerprint: 'Pl6dTESQ6oVCLz0wYnVwJCGh1t1V2X2E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
